import { LabelName } from '@modules/oracle/components/OracleConversationMarkdown/LabelName';
import { useFeedbackSummaryStore } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryStore';
import { SvgIconProps, TypographyProps } from '@mui/material';
import { Label } from 'generated/graphql';
import { ExtraProps } from 'react-markdown';

type FeedbackListSummaryPredictionProps = React.ClassAttributes<HTMLElement> &
  Omit<React.HTMLAttributes<HTMLElement>, 'onMouseEnter' | 'onMouseLeave'> &
  ExtraProps & {
    iconColor?: SvgIconProps['color'];
    textProps?: TypographyProps;
    onMouseEnter?: (
      event: React.MouseEvent,
      prediction: Label | undefined,
      feedbackCount: number | null,
    ) => void;
    onMouseLeave?: () => void;
  };

export const FeedbackListSummaryPrediction = (
  props: FeedbackListSummaryPredictionProps,
) => {
  const { onMouseEnter: onMouseEnterProp, node } = props;

  const messages = useFeedbackSummaryStore(({ data }) => data.messages);

  const labelID = node?.properties?.['id']
    ? String(node?.properties?.['id'])
    : '';

  const onMouseEnter = (event: React.MouseEvent) => {
    if (onMouseEnterProp) {
      const prediction = messages.find(
        (message) =>
          message.feedbackSummary?.token?.details?.label?.details.id ===
          labelID,
      )?.feedbackSummary?.token?.details?.label?.details;

      onMouseEnterProp(event, prediction, null);
    }
  };

  return <LabelName {...props} onMouseEnter={onMouseEnter} />;
};
